import { useMemo } from "react"

import { useMatch } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { APP_CAMPAIGN, MODULE_CAMPAIGNS, I18N_NAMESPACE, useCampaign } from "@l2r-front/l2r-shared-campaign"

import { useCampaignDetailContext } from "../../contexts/CampaignDetailContext"
import { CampaignMapRouter } from "../../routers/CampaignMapRouter"

import * as Styled from "./CampaignLayoutMap.styled"

export function CampaignLayoutMap() {

    const [{ viewMode }, { setViewMode }] = useCampaignDetailContext()
    const { t } = useTranslation(I18N_NAMESPACE)
    const matchCampaignDetail = useMatch(`:slugId/${APP_CAMPAIGN}/${MODULE_CAMPAIGNS}/:campaignId/*`)
    const campaignId = matchCampaignDetail?.params?.campaignId
    const { data: campaign } = useCampaign(campaignId)

    const options = useMemo(() => {
        return [{
            component: <Styled.Value selected={viewMode === "map"} variant="Desktop & Mobile/Body/Small">
                {t(I18N_NAMESPACE, "layout.selector.map")}
            </Styled.Value>,
            value: "map"
        }, {
            component: <Styled.Value selected={viewMode === "table"} variant="Desktop & Mobile/Body/Small">
                {t(I18N_NAMESPACE, "layout.selector.data-grid")}
            </Styled.Value>,
            value: "table"
        }]
    }, [viewMode, t])

    return <Styled.Wrapper>
        <Styled.Map>
            <CampaignMapRouter />
        </Styled.Map>
        {matchCampaignDetail && viewMode === "table" && !!campaign && <Styled.Table campaign={campaign} />}
        {matchCampaignDetail && viewMode === "table" && !campaign && <Styled.TableSkeleton />}
        {matchCampaignDetail && <Styled.ToggleButtonGroup
            id="campaign-layout-selector"
            onChange={setViewMode}
            enforceValue
            exclusive
            fullWidth
            value={viewMode}
            options={options}
        />}
    </Styled.Wrapper>
}